import React, { useState } from 'react';
import styles from './updatedata.module.scss';

const UpdateData = ({
  formList,
  updateFormLoading,
  updateFormSearchTerm,
  updateFormCurrentPage,
  updateFormTotalPages,
  updateFormItemsPerPage,
  handleUpdateFormSearch,
  handleUpdateFormPageChange,
  handleUpdateFormItemsPerPageChange,
  handleFormSelectForUpdate,
  handleBulkDelete,
  handleBulkExport,
  handleDuplicateForm
}) => {
  const [selectedForms, setSelectedForms] = useState([]);
  const [showBulkActions, setShowBulkActions] = useState(false);
  const [filterOffice, setFilterOffice] = useState('');
  const [filterDate, setFilterDate] = useState('');
  const [sortBy, setSortBy] = useState('created_at');
  const [sortOrder, setSortOrder] = useState('desc');

  // Handle form selection for bulk operations
  const handleFormSelection = (formId) => {
    setSelectedForms(prev => {
      if (prev.includes(formId)) {
        return prev.filter(id => id !== formId);
      } else {
        return [...prev, formId];
      }
    });
  };

  // Handle select all forms
  const handleSelectAll = () => {
    if (selectedForms.length === formList.length) {
      setSelectedForms([]);
    } else {
      setSelectedForms(formList.map(form => form.id));
    }
  };

  // Handle bulk delete
  const handleBulkDeleteClick = () => {
    if (selectedForms.length === 0) {
      alert('कृपया डाटा छान्नुहोस्');
      return;
    }
    
    if (handleBulkDelete) {
      handleBulkDelete(selectedForms);
      setSelectedForms([]);
    }
  };

  // Handle bulk export
  const handleBulkExportClick = () => {
    if (selectedForms.length === 0) {
      alert('कृपया डाटा छान्नुहोस्');
      return;
    }
    
    if (handleBulkExport) {
      handleBulkExport(selectedForms);
    }
  };

  // Filter forms based on search and filters
  const filteredForms = formList.filter(form => {
    const matchesSearch = !updateFormSearchTerm || 
      form.form_number?.toLowerCase().includes(updateFormSearchTerm.toLowerCase()) ||
      form.admission_report_number?.toLowerCase().includes(updateFormSearchTerm.toLowerCase()) ||
      form.office_name?.toLowerCase().includes(updateFormSearchTerm.toLowerCase());
    
    const matchesOffice = !filterOffice || 
      form.office_name?.toLowerCase().includes(filterOffice.toLowerCase());
    
    const matchesDate = !filterDate || 
      form.admission_date?.includes(filterDate);
    
    return matchesSearch && matchesOffice && matchesDate;
  });

  // Sort forms
  const sortedForms = [...filteredForms].sort((a, b) => {
    let aValue = a[sortBy];
    let bValue = b[sortBy];
    
    if (sortBy === 'created_at' || sortBy === 'admission_date') {
      aValue = new Date(aValue || 0);
      bValue = new Date(bValue || 0);
    } else {
      aValue = (aValue || '').toString().toLowerCase();
      bValue = (bValue || '').toString().toLowerCase();
    }
    
    if (sortOrder === 'asc') {
      return aValue > bValue ? 1 : -1;
    } else {
      return aValue < bValue ? 1 : -1;
    }
  });

  return (
    <div className={styles.dataUpdateContainer}>
      <div className={styles.header}>
        <h2>डाटा अपडेट र व्यवस्थापन</h2>
        <p className={styles.subtitle}>फारम ४०३ को डाटा अपडेट, मेटाउने र निर्यात गर्ने</p>
      </div>
      
      {/* Enhanced Search and Controls */}
      <div className={styles.controlsContainer}>
        <div className={styles.searchSection}>
          <div className={styles.searchBox}>
            <input
              type="text"
              placeholder="फारम नं, प्रतिवेदन नं, वा कार्यालय खोज्नुहोस्..."
              value={updateFormSearchTerm}
              onChange={handleUpdateFormSearch}
              className={styles.searchInput}
            />
            <button className={styles.searchButton}>
              🔍
            </button>
          </div>
          
          <div className={styles.filterSection}>
            <input
              type="text"
              placeholder="कार्यालय फिल्टर..."
              value={filterOffice}
              onChange={(e) => setFilterOffice(e.target.value)}
              className={styles.filterInput}
            />
            <input
              type="date"
              placeholder="मिति फिल्टर..."
              value={filterDate}
              onChange={(e) => setFilterDate(e.target.value)}
              className={styles.filterInput}
            />
          </div>
        </div>
        
        <div className={styles.actionsSection}>
          <div className={styles.sortSection}>
            <label>क्रमबद्ध गर्नुहोस्:</label>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className={styles.sortSelect}
            >
              <option value="created_at">सिर्जना मिति</option>
              <option value="admission_date">दाखिला मिति</option>
              <option value="form_number">फारम नं</option>
              <option value="office_name">कार्यालय</option>
            </select>
            <button
              onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
              className={styles.sortButton}
            >
              {sortOrder === 'asc' ? '↑' : '↓'}
            </button>
          </div>
          
          <div className={styles.itemsPerPageContainer}>
            <label>प्रति पृष्ठ:</label>
            <select
              value={updateFormItemsPerPage}
              onChange={handleUpdateFormItemsPerPageChange}
              className={styles.itemsPerPageSelect}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
        </div>
      </div>

      {/* Bulk Actions */}
      <div className={styles.bulkActionsContainer}>
        <div className={styles.bulkActionsHeader}>
          <label className={styles.selectAllLabel}>
            <input
              type="checkbox"
              checked={selectedForms.length === formList.length && formList.length > 0}
              onChange={handleSelectAll}
              className={styles.selectAllCheckbox}
            />
            सबै छान्नुहोस् ({selectedForms.length}/{formList.length})
          </label>
          
          {selectedForms.length > 0 && (
            <div className={styles.bulkActionButtons}>
              <button
                onClick={handleBulkDeleteClick}
                className={`${styles.bulkActionButton} ${styles.deleteButton}`}
              >
                🗑️ मेटाउनुहोस् ({selectedForms.length})
              </button>
              <button
                onClick={handleBulkExportClick}
                className={`${styles.bulkActionButton} ${styles.exportButton}`}
              >
                📄 निर्यात गर्नुहोस् ({selectedForms.length})
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Loading State */}
      {updateFormLoading ? (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingSpinner}></div>
          <p>फारमहरू लोड गर्दै...</p>
        </div>
      ) : (
        <>
          {/* Enhanced Forms Table */}
          <div className={styles.tableContainer}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th className={styles.checkboxColumn}>
                    <input
                      type="checkbox"
                      checked={selectedForms.length === formList.length && formList.length > 0}
                      onChange={handleSelectAll}
                      className={styles.headerCheckbox}
                    />
                  </th>
                  <th>क्र.सं.</th>
                  <th>फारम नं.</th>
                  <th>दाखिला मितिः</th>
                  <th>दाखिला प्रतिवेदन नं.</th>
                  <th>कार्यालय</th>
                  <th>जिन्सी खाता पाना नं.</th>
                  <th>सामानको नाम</th>
                  <th>कार्यालय ठेगाना</th>
                  <th>सिर्जना मिति</th>
                  <th>कार्य</th>
                </tr>
              </thead>
              <tbody>
                {sortedForms.map((form, index) => (
                  <tr key={form.id} className={selectedForms.includes(form.id) ? styles.selectedRow : ''}>
                    <td className={styles.checkboxColumn}>
                      <input
                        type="checkbox"
                        checked={selectedForms.includes(form.id)}
                        onChange={() => handleFormSelection(form.id)}
                        className={styles.rowCheckbox}
                      />
                    </td>
                    <td>{((updateFormCurrentPage - 1) * updateFormItemsPerPage) + index + 1}</td>
                    <td className={styles.formNumber}>{form.form_number || 'N/A'}</td>
                    <td>{form.admission_date || 'N/A'}</td>
                    <td>{form.admission_report_number || 'N/A'}</td>
                    <td className={styles.officeName}>{form.office_name || 'N/A'}</td>
                    <td className={styles.ledgerPage}>{form.first_item_ledger_page || 'N/A'}</td>
                    <td className={styles.itemName}>{form.first_item_name || 'N/A'}</td>
                    <td className={styles.officeAddress}>{form.office_address || 'N/A'}</td>
                    <td>{new Date(form.created_at).toLocaleDateString('ne-NP')}</td>
                    <td className={styles.actionButtons}>
                      <button
                        onClick={() => handleFormSelectForUpdate(form.id)}
                        className={`${styles.actionButton} ${styles.editButton}`}
                        title="सम्पादन गर्नुहोस्"
                      >
                        ✏️ सम्पादन
                      </button>
                      <button
                        onClick={() => {
                          // TODO: Implement view functionality
                          console.log('View form:', form.id);
                        }}
                        className={`${styles.actionButton} ${styles.viewButton}`}
                        title="हेर्नुहोस्"
                      >
                        👁️ हेर्नुहोस्
                      </button>
                      <button
                        onClick={() => {
                          if (handleDuplicateForm) {
                            handleDuplicateForm(form.id);
                          }
                        }}
                        className={`${styles.actionButton} ${styles.duplicateButton}`}
                        title="नक्कल बनाउनुहोस्"
                      >
                        📋 नक्कल
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Enhanced Pagination */}
          {updateFormTotalPages > 1 && (
            <div className={styles.paginationContainer}>
              <div className={styles.paginationInfo}>
                <span>
                  पृष्ठ {updateFormCurrentPage} को {updateFormTotalPages} 
                  ({formList.length} फारमहरू)
                </span>
              </div>
              
              <div className={styles.paginationButtons}>
                <button
                  onClick={() => handleUpdateFormPageChange(1)}
                  disabled={updateFormCurrentPage === 1}
                  className={styles.paginationButton}
                  title="पहिलो पृष्ठ"
                >
                  ⏮️ पहिलो
                </button>
                <button
                  onClick={() => handleUpdateFormPageChange(updateFormCurrentPage - 1)}
                  disabled={updateFormCurrentPage === 1}
                  className={styles.paginationButton}
                  title="अघिल्लो पृष्ठ"
                >
                  ◀️ अघिल्लो
                </button>
                
                {Array.from({ length: Math.min(5, updateFormTotalPages) }, (_, i) => {
                  const page = Math.max(1, Math.min(updateFormTotalPages - 4, updateFormCurrentPage - 2)) + i;
                  return (
                    <button
                      key={page}
                      onClick={() => handleUpdateFormPageChange(page)}
                      className={`${styles.paginationButton} ${updateFormCurrentPage === page ? styles.activePage : ''}`}
                    >
                      {page}
                    </button>
                  );
                })}
                
                <button
                  onClick={() => handleUpdateFormPageChange(updateFormCurrentPage + 1)}
                  disabled={updateFormCurrentPage === updateFormTotalPages}
                  className={styles.paginationButton}
                  title="अर्को पृष्ठ"
                >
                  अर्को ▶️
                </button>
                <button
                  onClick={() => handleUpdateFormPageChange(updateFormTotalPages)}
                  disabled={updateFormCurrentPage === updateFormTotalPages}
                  className={styles.paginationButton}
                  title="अन्तिम पृष्ठ"
                >
                  अन्तिम ⏭️
                </button>
              </div>
            </div>
          )}

          {/* No Data Message */}
          {formList.length === 0 && !updateFormLoading && (
            <div className={styles.noDataContainer}>
              <div className={styles.noDataIcon}>📋</div>
              <p>कुनै फारमहरू फेला परेनन्।</p>
              <p className={styles.noDataSubtext}>
                कृपया खोज शब्द वा फिल्टर परिवर्तन गर्नुहोस्।
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default UpdateData;
